<template>
  <v-container id="foot" fluid>
    
      <v-layout row wrap justify-center align-center>
        <img id="large" src="../assets/credits.png" class="credits">
        <img id="mobile" src="../assets/credits_mobile.png" class="credits">
      </v-layout>
    <v-footer  id="footer">
      <v-layout row wrap justify-center align-center>
        <v-flex text-xs-right>
          <strong>Página web </strong> www.letraese.org.mx
        </v-flex>
        <v-flex text-xs-center>
          <i class="fab fa-twitter fa-lg"></i> @letraese
        </v-flex>
        <v-flex text-xs-left>
          <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fab fa-facebook-f fa-stack-1x fa-inverse back"></i>
          </span>
          facebook.com/agencianotieseoficial
        </v-flex>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<style>
#footer {
  background-color: #000000;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  padding: 1rem;
  height: 70px !important;
}
strong {
  color: #be3117;
}
.back {
  color: black;
}

#foot {
  padding: 0;
}
.credits {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-height: 200px;
  min-height: 140px;
  max-width: 100%;
}

#mobile {
  display: none;
}

@media (max-width: 600px) {
  #mobile {
    display: block;
  }
  #large {
    display: none;
  }
}
</style>

<script>
export default {
  name: "Footer",
  props: {}
};
</script>
